export default "__VITE_ASSET__CfIhU_CE__"